import React from 'react';
import PropTypes from 'prop-types';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';

const InvitationsCreateForm = (props) => {

    const {
        handleSubmit,
        handleSubmitForm,
        translate,
        pristine,
        submitting,
        invalid,
    } = props;

    return (
        <FormWrapper>
            <form onSubmit={ handleSubmit(handleSubmitForm) }>
                <Section>
                    <Row>
                        <Item>
                            <Field
                                component={ RenderTextInputField }
                                fullWidth={ true }
                                label={ translate('filters.components.email.label') }
                                name='email'
                                validate={ validations.email }
                            />
                        </Item>
                    </Row>
                    <Row>
                        <ButtonWrapper>
                            <SubmitButton
                                disabled={ pristine || submitting || invalid }
                                loading={ submitting }
                            />
                        </ButtonWrapper>
                    </Row>
                </Section>
            </form>
        </FormWrapper>
    );
};

InvitationsCreateForm.propTypes = {
    formValues: PropTypes.shape({
        values: PropTypes.shape({
            email: PropTypes.string,
        }),
    }),
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
        formValues: state.form[form] || {},
        initialValues: {
            email: '',
        },
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm(),
);

export default enhance(InvitationsCreateForm);


// WEBPACK FOOTER //
// ./src/pages/invitations/list/create/InvitationsCreateForm.js